import { render } from "./HomeAbout.vue?vue&type=template&id=be3e01e4&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"

import "./HomeAbout.vue?vue&type=style&index=0&id=be3e01e4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be3e01e4"]])

export default __exports__